import { createModule } from '../actions/utils';
import { SERVICE_ENDPOINT } from '../apis/constants';

const CreateSoFromPo = createModule({
  base: 'CREATE_SO_FROM_PO', apiDetails: SERVICE_ENDPOINT.CREATE_SO_FROM_PO, 
  errors: { defaultError: true, customError: '' }, 
  enableNotification: true,
});

export { CreateSoFromPo };
